import React, { Component } from 'react';
import { connect, getIn } from 'formik';
import ErrorMessageTemplate from './ErrorMessageTemplate';
//OnChange show error message, created because default component shows error only on blur (touched)
class ErrorMessageInstant extends Component {
  shouldComponentUpdate(props) {
    if (
      getIn(this.props.formik.errors, this.props.name) !==
        getIn(props.formik.errors, this.props.name) ||
      getIn(this.props.formik.touched, this.props.name) !==
        getIn(props.formik.touched, this.props.name) ||
      Object.keys(this.props).length !== Object.keys(props).length
    ) {
      return true;
    } else {
      return false;
    }
  }

  render() {
    let { component, formik, render, children, name, ...rest } = this.props;

    //    const touch = getIn(formik.touched, name);
    const error = getIn(formik.errors, name);

    //const isTouched = !!touch;
    const isError = !!error;
    return isError ? (
      render ? (
        typeof render === 'function' ? (
          render(error)
        ) : null
      ) : children ? (
        typeof children === 'function' ? (
          children(error)
        ) : null
      ) : component ? (
        React.createElement(component, rest, error)
      ) : (
        <ErrorMessageTemplate message={error} />
      )
    ) : null;
  }
}

export default connect(ErrorMessageInstant);
